<template>
  <div v-if="isUS">
    <SportsFilter
      v-show="sports.length > 0 && !searchBySport"
      :list="getSports"
      :selectedSport="activeSportId"
      @changeSport="changeSport" />
    <MatchListUsComponent
      :sports="sports"
      :matchList="highlightsData"
      :showMarketsInMatch="showMarketsInMatch"
      :showEventCode="showEventCode"
      :showTeamIcon="showTeamIcon"
      :showFavorites="showFavorites"
      :showStatistics="showStatistics"
      :widgetClass="'bto-sb-widget-highlights'"
      :isCategoryList="false"
      :isLiveSport="false"
      :matchType="'highlights'" />
  </div>
  <div :class="['bto-sb-widget',
    'bto-sb-widget-prematch',
    singleMarketView ? 'bto-sb-widget-prematch-3w' : 'bto-sb-widget-prematch-full-view',
    'bto-sb-widget-highlights']"
    v-else>
    <title-component
      @toggleViewMode="toggleViewMode"
      :name="t('Mobile.Highlights')"
      :hasFilter="false">
    </title-component>
    <div class="bto-sb-widget-content">
      <sports-list-component :sports="sports" @changeSport="changeSport" :selected-sport="activeSportId" v-show="sports.length > 0 && !searchBySport"/>
      <odds-nav-component
        v-if="highlightsData.length > 0"
        @changecombi="getCombiData"
        @comboOddType="comboOddType"
        :is3WaySport="isThreeWay"
        :sportId="activeSportId !== 0 ? activeSportId : parseInt(sports[0], 10) || 0"
        :numberOfMarkets="parseFloat(numberOfMarkets)"
        :showEventCode="showEventCode">
      </odds-nav-component>
      <empty-state v-if="highlightsData.length === 0" :message="emptyStateStatusMessage" :iconClass="emptyStateClass"/>
      <div class="bto-sb-event-odds-content" v-show="highlightsData.length > 0">
        <component
          :is="matchItemComp"
          v-for="match in highlightsData" :key="match.matchId"
          :item="match"
          :singleMarketView="singleMarketView"
          :template="template"
          :showFirstCombo="showFirstCombo"
          :showSecondCombo="showSecondCombo"
          :is3WaySport="isThreeWay"
          :firstComboOddType="firstComboOddType"
          :secondComboOddType="secondComboOddType"
          :showMarketsInMatch="showMarketsInMatch"
          :showEventCode="showEventCode"
          :showTeamIcon="showTeamIcon"
          :showFavorites="showFavorites"
          :showStatistics="showStatistics"
          :eventDescription="`${showCategory ? match.categoryName : ''}
          ${showCategory && showTournament ? '-' : ''}
          ${showTournament ? match.tournamentName : ''}`"
          @showCombsLeg="showCombsLeg">
        </component>
      </div>
      <!-- legend -->
      <combinability-legend-component v-if="showCombinabilityLeg" />
    </div>
  </div>
</template>

<script>
  import store from '../../../store/index';
  import { EmptyState, ICON_CLASS } from '../../shared/empty-state';
  import TitleComponent from '../../common/match/title-component';
  import SportsListComponent from '../../common/match/sports-list-component';
  import OddsNavComponent from '../../common/match/odds-nav-component';
  import CombinabilityLegendComponent from '../../shared/combinability-legend-component';
  import MatchItemComp from '../../common/match-item/match-item-comp';
  import LatamItemComp from '../../common/match-item/match-item-latam';
  import MatchListUsComponent from '../../common/match-list-us-component';
  import { MARKET_TYPE_IDS } from '../../../models/enums/market-const';
  import { LAYOUT_NAME } from '../../../models/enums/layout-const';
  import SportsFilter from "@bto-widgets/selector/web";

  export default {
    name: 'HighlightsWidget',
    data() {
      return {
        // isThreeWay: true,
        startRecord: 0,
        singleMarketView: false,
        showFirstCombo: this.numberOfMarkets > 1,
        showSecondCombo: this.numberOfMarkets > 2,
        firstComboOddType: {},
        secondComboOddType: {},
        showCombinabilityLeg: false,
        emptyStateIcon: ICON_CLASS.HIGHLIGHTS,
        loadingSpinner: ICON_CLASS.LOADING,
        isUS: APP_SETTINGS.settings.layout === LAYOUT_NAME.US,
        selectedSportsTab: APP_SETTINGS.settings.selectedSportsTab,
      };
    },
    props: {
      template: {
        type: String,
        default: '',
        label: 'Template',
      },
      endRecord: {
        type: String,
        default: '5',
        label: 'number of matches',
      },
      numberOfMarkets: {
        type: String,
        default: '3',
        label: 'number of markets',
      },
      showMarketsInMatch: {
        type: Boolean,
        default: true,
        label: 'show number of markets instead odss',
      },
      showEventCode: {
        type: Boolean,
        default: true,
        label: 'show event code',
      },
      showTeamIcon: {
        type: Boolean,
        default: false,
        label: 'show team icon',
      },
      showCategory: {
        type: Boolean,
        default: false,
        label: 'show category',
      },
      showTournament: {
        type: Boolean,
        default: false,
        label: 'show tournament',
      },
      showFavorites: {
        type: Boolean,
        default: false,
        label: 'show Favorites option',
      },
      showStatistics: {
        type: Boolean,
        default: false,
        label: 'show statistics option',
      },
      searchBySport: {
        type: Number,
        default: 0,
        label: 'show highlights by specific sport',
        excluded: true,
      }
    },
    computed: {
      emptyStateClass() {
        return this.loading ? this.loadingSpinner : this.emptyStateIcon;
      },
      emptyStateStatusMessage() {
        return this.loading ? this.t('Mobile.LoadingMore') : this.t('A.NoHighlights');
      },
      sports() {
        return store.getters.getHighlightsSports;
      },
      activeSportId() {
        return this.searchBySport ? this.searchBySport : store.getters.selectedHighlightsSportId;
      },
      highlightsData() {
        return store.getters.getHighlightsMatches;
      },
      isThreeWay() {
        let getSportType = store.getters.getSportType;
        return getSportType(this.activeSportId) === MARKET_TYPE_IDS.THREE_WAY;
      },
      matchItemComp() {
        if (this.singleMarketView) {
          return LatamItemComp;
        }
        return MatchItemComp;
      },
      loading() {
        return store.getters.getHighlightsLoadingStatus;
      },
      getSports() {
        let widgetSports = [];
        let sportsIds = this.sports;
        let allSports = store.state.SportsModule.allSportsData;
        sportsIds.forEach((s) => {
          if (typeof allSports[s] !== 'undefined') {
            widgetSports.push({
              name: allSports[s].name,
              class: allSports[s].class,
              id: allSports[s].id,
            });
          }
        });

        this.pushAllSportsLast(widgetSports, APP_SETTINGS.settings.showAllSportsLast);

        return widgetSports;
      },
    },
    created() {
      const defaultSelectedSportId = APP_SETTINGS.settings.selectedSportsTab === 'allSports' ? -1 : null; 
      this.getData(this.activeSportId || defaultSelectedSportId);
      if (this.isUS && this.selectedSportsTab === "allSports") {
        store.commit('changeHighlightsSport', -1);
      }
    },
    methods: {
      getData(sportId = null) {
        const params = {
          sportId: sportId === -1 ? null : sportId,
          startRecord: this.startRecord,
          endRecord: parseFloat(this.endRecord),
          numberOfOddTypes: parseFloat(this.numberOfMarkets),
          IncludeAllSports: this.isUS && sportId === -1,
        };
        if (this.searchBySport) {
          params.IncludeAllSports = false;
        }
        store.dispatch('getHighlightsItems', params);
      },
      changeSport(sportId) {
        if (store.state.HighlightsModule.selectedHighlightsSportId === sportId) {
          return;
        }
        store.commit('changeHighlightsSport', sportId);
        this.getData(sportId);
      },
      getCombiData(combi, combiIndex) {
        let payload = {
          oddType: combi.ot,
          outcomes: combi.o,
          combiIndex: combiIndex,
          name: combi.n,
          isMostBalanced: combi.mb,
        };
        store.dispatch('changeHighlightsCombi', payload);
      },
      comboOddType(oddType, combiIndex) {
        const oddTypeId = oddType.ot || 0;
        switch (combiIndex) {
          case 1:
            this.firstComboOddType = oddType;
            this.showFirstCombo = oddTypeId !== 0 && this.numberOfMarkets > 1;
            break;
          case 2:
            this.secondComboOddType = oddType;
            this.showSecondCombo = oddTypeId !== 0 && this.numberOfMarkets > 2;
            break;
        }
      },
      toggleViewMode(isSingleView) {
        this.singleMarketView = isSingleView;
      },
      showCombsLeg(flag) {
        this.showCombinabilityLeg = flag;
      },
      pushAllSportsLast(array, bool) {
        const allSports = {
          name: this.$translate.text('Mobile.AllSports'),
          class: 'all-sports',
          id: -1,
        };
        if(bool) {
          array.push(allSports);
        } else {
          array.unshift(allSports);
        }
      }
    },
    components: {
      TitleComponent,
      SportsListComponent,
      OddsNavComponent,
      CombinabilityLegendComponent,
      EmptyState,
      MatchListUsComponent,
      SportsFilter,
    },
  };
</script>
